import { AppInput, AppSelect } from "../../scraper";

const MarketingFunnelFilters = ({ filters, options = {}, onChange, onReset }) => {
    const { sources = [], campaigns = [],} = options;
    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-slate-50 to-white p-4">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-sm font-semibold text-slate-900">Funnel Filters</h3>
                    <p className="mt-0.5 text-xs text-slate-500">Analyze visitors by campaign and conversion</p>
                </div>
                <button
                    onClick={onReset}
                    className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:bg-slate-50"
                >
                    Reset Filters
                </button>
            </div>

            <div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-5">
                <AppInput
                    label="Email"
                    value={filters.search}
                    onChange={(e) => onChange("search", e.target.value)}
                    placeholder="Search email..."
                />
                <AppSelect
                    label="Source"
                    placeholder="All Sources"
                    value={filters.utm_source}
                    options={sources}
                    onChange={(e) => onChange("utm_source", e.target.value)}
                />
                <AppSelect
                    label="Campaign"
                    placeholder="All Campaigns"
                    value={filters.utm_campaign}
                    options={campaigns}
                    onChange={(e) => onChange("utm_campaign", e.target.value)}
                />
                <AppSelect
                    label="User Type"
                    placeholder="All Users"
                    value={filters.user_type}
                    options={[
                        { label: "Guest", value: "guest" },
                        { label: "Artist", value: "user" },
                        { label: "Organization", value: "organization" },
                    ]}
                    onChange={(e) => onChange("user_type", e.target.value)}
                />
                <AppSelect
                    label="Payment"
                    placeholder="All Visitors"
                    value={filters.paid}
                    options={[
                        { label: "Paid", value: "1" },
                        { label: "Not Paid", value: "0" },
                    ]}
                    onChange={(e) => onChange("paid", e.target.value)}
                />
            </div>
        </div>
    );
};

export default MarketingFunnelFilters;